import { render, staticRenderFns } from "./ChannelSupplierStatistics.vue?vue&type=template&id=d327ed0a&"
import script from "./ChannelSupplierStatistics.vue?vue&type=script&lang=ts&"
export * from "./ChannelSupplierStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChannelSupplierStatistics.vue"
export default component.exports